import React, { useEffect, useState } from 'react';

// Styled Components Import
import styled from 'styled-components';

// Animation on Scroll
import Zoom from 'react-reveal/Zoom';

// Bootstrap Imports
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';

// Fontawessome Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faCog,
	faSearch,
	faStopwatch,
	faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

// Firebase Imports
import { storage } from '../../../config/fbConfig';

// Styled Components
const CounselingTopBackground = styled.div`
	background: url('${(props) => props.backgroundIamge}') no-repeat;
	background-size: cover;
	height: 250px;
	padding-top: 60px;

	@media (min-width: 768px) {
		padding-top: 70px;
	}
`;

const Counseling = () => {
	// Component State
	const [backgroundIamge, setBackgroundImage] = useState('');

	// Component Hooks
	useEffect(() => {
		storage
			.ref('static-web-imgs')
			.child('purple-background_1440x810.jpg')
			.getDownloadURL()
			.then((res) => {
				setBackgroundImage(res);
			});
	}, []);

	return (
		<div className='pb-5 pb-md-0'>
			<CounselingTopBackground
				className='d-flex align-items-md-baseline justify-content-center text-center'
				backgroundIamge={backgroundIamge}>
				<h1 className='counsueling-title' style={{ color: '#fff' }}>
					Asesoramiento en
				</h1>
			</CounselingTopBackground>
			<Row
				className='d-flex align-items-center justify-content-center pb-5 mx-2 mx-md-3'
				style={{ marginTop: -120, maxWidth: '100%' }}>
				<Col
					className='d-flex flex-column align-items-end justify-content-between pt-5 pr-md-0'
					xs={{ span: 12, order: 2 }}
					md={{ span: 3, order: 1 }}
					style={{ height: 240 }}>
					<Zoom>
						<div>
							<Row className='d-flex align-items-center mb-5 mx-0'>
								<Col
									xs={{ span: 9, order: 2 }}
									md={{ span: 9, order: 1 }}
									className='counseling-text text-sm-left text-md-right px-0 pl-3 pl-md-0'
									style={{ color: '#3B968D' }}>
									Implementación y gestión de redes sociales
								</Col>
								<Col
									xs={{ span: 3, order: 1 }}
									md={{ span: 3, order: 2 }}
									className='d-flex justify-content-md-end pr-md-0'>
									<div
										className='counseling-icon-container ml-0 ml-md-4'
										style={{ backgroundColor: '#3B968D' }}>
										<FontAwesomeIcon
											icon={faCog}
											style={{ fontSize: '1.7rem' }}
										/>
									</div>
								</Col>
							</Row>
						</div>
					</Zoom>
					<Zoom>
						<div>
							<Row className='d-flex align-items-center mb-5 mx-0 mt-0 mt-md-3'>
								<Col
									xs={{ span: 9, order: 2 }}
									md={{ span: 9, order: 1 }}
									className='counseling-text text-sm-left text-md-right px-0 pl-3 pl-md-0'
									style={{ color: '#2E7F9C' }}>
									Diseño y Estrategia Digital
								</Col>
								<Col
									xs={{ span: 3, order: 1 }}
									md={{ span: 3, order: 2 }}
									className='d-flex justify-content-md-end pr-md-0'>
									<div
										className='counseling-icon-container ml-0 ml-md-4'
										style={{ backgroundColor: '#2E7F9C' }}>
										<FontAwesomeIcon
											icon={faSearch}
											style={{ fontSize: '1.7rem' }}
										/>
									</div>
								</Col>
							</Row>
						</div>
					</Zoom>
				</Col>
				<Col
					className='d-flex justify-content-center px-0'
					xs={{ span: 12, order: 1 }}
					md={{ span: 4, order: 2 }}>
					<Image
						src='/img/counseling-phone.png'
						alt='Majo Cobos - Asesoramiento'
						style={{ maxWidth: '100%' }}
					/>
				</Col>
				<Col
					className='d-flex flex-column align-items-baseline justify-content-between pt-5 pl-md-0'
					xs={{ span: 12, order: 3 }}
					md={{ span: 3, order: 3 }}
					style={{ height: 240 }}>
					<Zoom>
						<div>
							<Row
								className='d-flex align-items-center mb-4 mb-md-5 mx-0'
								style={{ width: '100%' }}>
								<Col xs={3} md={3} className='pl-md-0'>
									<div
										className='counseling-icon-container ml-0'
										style={{ backgroundColor: '#644691' }}>
										<FontAwesomeIcon
											icon={faUserCircle}
											style={{ fontSize: '1.7rem' }}
										/>
									</div>
								</Col>
								<Col
									xs={9}
									md={9}
									className='counseling-text text-left px-0 pl-3 pl-md-0'
									style={{ color: '#644691', height: 84 }}>
									Construcción de
									<br />
									Marca Personal
								</Col>
							</Row>
						</div>
					</Zoom>
					<Zoom>
						<div>
							<Row
								className='d-flex align-items-center mb-5 mx-0 mt-2 mt-md-0'
								style={{ width: '100%' }}>
								<Col xs={3} md={3} className='pl-md-0'>
									<div
										className='counseling-icon-container ml-0'
										style={{ backgroundColor: '#540963' }}>
										<FontAwesomeIcon
											icon={faStopwatch}
											style={{ fontSize: '1.7rem' }}
										/>
									</div>
								</Col>
								<Col
									xs={9}
									md={9}
									className='counseling-text text-left px-0 pl-3 pl-md-0'
									style={{ color: '#540963' }}>
									Creación de Embudos
									<br />
									de Ventas Digitales
								</Col>
							</Row>
						</div>
					</Zoom>
				</Col>
			</Row>
		</div>
	);
};

export default Counseling;
